<template>
  <div class="web">
    <v-header :config="headerData" 
              @startLesson="startLive" 
              @endLesson="endLive" 
              @IQNaire="issueQuestion" 
              @studentQA="askQuestion" 
              @clearEditor="clearCode" 
              @checkCode="checkRole" 
              @exportFile="exportCode">
    </v-header>
    <!-- <k-header :headerData="headerData">
      <span class="live-btn" @click="issueQuestion">发布问卷</span>
      <span class="live-btn" @click="askQuestion">
        学生提问
        <span class="qa-tip">{{qaSet.length}}</span>
      </span>
      <span v-if="isLive == 0" class="live-btn t-start" @click="startLive">开始</span>
      <span v-if="isLive == 1" class="live-btn t-end" @click="endLive">结束</span>
      <span class="live-btn t-clear" @click="clearCode">清除代码</span>
      <span class="live-btn t-clear" @click="exportCode">导出代码</span>
    </k-header> -->
    <drag :options="optionData" class="dragwrap">
      <div class="work" slot='uLeft' ref="work">
        <textarea ref="webEditor"></textarea>
        <div class="qa-wrap" v-show="isShowQA" ref="qaWrap">
          <div class="qa-notice">
            点击学生名字查看代码
          </div>
          <div class="qa-list">
            <div class="qa-item":class="qaItemActiveIndex == index?'active':''" @click="getItemCode(item); qaItemActiveIndex=index" v-for="(item, index) in qaSet" :key="'qa-' + index">
              <span>{{item.name || '匿名学员'}}</span>
              <i class="icon iconfont icon-guanbi" @click="closeQAItem(index)"></i>
            </div>
          </div>
          <div class="qa-close" @click.stop="closeQAWrap">
            <span>关闭问答</span>
          </div>
        </div>
      </div>
      <div class="work iterm" slot='uRight'>
        <browser :options="browserOption" :code="editorContent" @insertCodeSnippet="insertData"></browser>
      </div>
    </drag>
    <div class="countdown" v-show="countdown">
     <h1>{{count}}</h1>
    </div>
    <div class="qatip tip-wrap" v-if="qatip">
      <div class="t-header">
        <p>提示</p>
        <p><i class="icon iconfont icon-guanbi" @click="qatip=!qatip"></i></p>
      </div>
      <div class="ti-wrap">
        <p>当前直播窗口为学生窗口，需要将直播窗口切换给老师吗？点击‘切换’将关闭学生窗口。</p>
      </div>
      <div class="tb-wrap">
        <div class="notip">
          <i class="icon iconfont icon-baochi" :class="{activeTip: isActiveTip}" @click="noTip"></i>不再提醒
        </div>
        <div class="">
          <button @click="checkMenu">切换</button>
          <button @click="noCheckMenu">不切换</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Drag from '@/components/Drag'
import CodeMirror from 'codemirror'
import 'codemirror/lib/codemirror.css'
import 'codemirror/mode/htmlmixed/htmlmixed'
import 'codemirror/addon/hint/show-hint'
import 'codemirror/addon/hint/html-hint'
import 'codemirror/addon/hint/show-hint.css'
import 'codemirror/theme/base16-dark.css'
import '@/utils/minEmmet'

import { RestoreAction } from '@/utils/utils'
// import kHeader from '@/components/Header'
import vHeader from '@/components/HeaderV2'
import Browser from '@/components/Browser'
import { ajaxAPI } from '@/utils/ajaxUtil'
import IO from 'socket.io-client'
import { url, HYBIRD_URL } from '@/config/url_config'
import { launchFullScreen, exitFullscreen, insertLibrary, exportFile } from '@/utils/utils'
import EventBus from '@/views/eventBus'
export default {
  components: {
    Drag,
    // kHeader,
    vHeader,
    Browser
  },
  data () {
    return {
      optionData: {
        layout: 'u-d'
      },
      headerData: {
        role: 1,
        roomId: this.$route.params.roomId,
        number: '0',
        isLive: false,
        qaTime: false,
        isQA: false,
        nameQA: '',
        forceChangeQAIndex: 0
      },
      browserOption: {
        role: 0
      },
      isLive: 0,
      count: 3,
      isFullscreen: 0,
      editorContent: '',
      countdown: false,
      isShowQA: false,
      qaSet: [],
      qaNum: 0,
      qatip: false,
      qaItemActiveIndex: -1,
      isTip: true,
      isActiveTip: false,
      n: 'one',           // 切换到学生代码        
      check: 'live',      // 切换到直播
      isGetCode: true     // 是否获取页面代码
    }
  },
  created () {
  },
  mounted () {
    this.initEditor()
    this.initSocket()

    EventBus.$on('closeQAMenu', () => {
      if (this.isTip) {
        this.qatip = true
      } else {
        // this.headerData.isQA = false
        this.checkMenu()
      }
    })
  },
  watch: {
  },
  computed: {
  },
  methods: {
    initEditor () {
      let _this = this;
      const editor = this.editor = CodeMirror.fromTextArea(this.$refs.webEditor, {
        // theme: 'base16-dark',
        autofocus: true,
        lineNumbers: true,
        matchBrackets: true,
        autoCloseBrackets: true,
        tabSize: 4,
        mode: 'text/html',
        line: true,
        profile: 'xhtml'
        // extraKeys: {"Tab": "autocomplete"}
      })
      // emmet.emmetCodeMirror(editor)
      CodeMirror.on(editor, "change", function(instance, changeObj) {
        _this.editorContent = instance.getValue()
        _this.$store.state.codeContent = instance.getValue()

        if (_this.check === 'live') {
          console.log('live')
          _this.socket.emit('action.code', changeObj, _this.$route.params.roomId)
          _this.socket.emit('programming.content', _this.$store.state.codeContent, _this.$route.params.roomId)
        }

        _this.codeContent = editor.getValue()
        _this.showView(editor.getValue())
      });
    },
    initSocket () {
      let _this = this
      
      _this.socket.on('student.number', function (data) {
        console.log('student.number==========:', data)
        _this.headerData.number = data || '0'
      })

      _this.socket.on('teacher.room.data', function (data, id) {
        console.log('teacher.room.data:', data)
        window.localStorage.setItem('roomData', data)
        _this.headerData.number = data.number || '0'
      })

      _this.socket.on('student.qa', function (data) {
        console.log('student.qa:', data)
        _this.qaSet.push(data)
      })

    },
    showView (code) {
    },
    insertData(index) {
      console.log('index', index)
      let editor = this.editor
      insertLibrary(index, editor)
    },
    startLive () {
      let _this = this

      _this.countdown = true
      _this.isLive = 1

      _this.socket.emit('start.live', this.$route.params.roomId)
      console.log(this.$route.params.roomId)
      // _this.socket.emit('start.live')
      // 倒计时
      var countdown = setInterval(function () {
        console.log(_this.count)
        _this.count--
        if (_this.count === -1) {
          _this.countdown = false
          clearInterval(countdown)
          _this.count = 3
          _this.headerData.isLive = true
          // _this.socket.emit('sync.programming')
        }
      }, 1000)
    },
    endLive () {
      console.log('classRoom')
      let socket = IO(url)
      socket.emit('clear.editor', this.$route.params.roomId)
      this.$router.push({name: 'ClassRoom'})
    },
    quickTool (index) { 
      let editor = this.editor
      insertLibrary(index, editor)
      this.$refs.dropDown.style.display = 'none'
      this.dropDown = false
    },
    clearCode () {
      // EventBus.$emit('clearResult')
      this.socket.emit('clear.editor', this.$route.params.roomId)
      this.socket.emit('handle.run', '', this.$route.params.roomId)
      this.editor.setValue('')
      this.$store.state.codeContent = ''
    },
    showDropDown () {
      if (!this.dropDown) {
        this.dropDown = true
        this.$refs.dropDown.style.display = 'block'
      } else {
        this.dropDown = false
        this.$refs.dropDown.style.display = 'none'
      }
    },
    exportCode() {
      var content = this.editor.getValue()
      var filename = 'lesson.html'
      exportFile(content, filename)
    },
    issueQuestion() {
      console.log('999999')
      EventBus.$emit('showQuestionPanel')
    },
    askQuestion() {
      let _this = this;
      this.isShowQA = !this.isShowQA
      let work = this.$refs.work
      let height = 0
      this.$nextTick(function(){
        let qaWrapHeight = _this.$refs.qaWrap.clientHeight
        if (_this.isShowQA) {
          let time = setInterval(function(){
            work.style.height = "calc(100% - " + height +"px)"
            height += 10
            if (height >= qaWrapHeight) {
              work.style.height = "calc(100% - " + qaWrapHeight +"px)"
              clearInterval(time)
            }
          }, 10)
        } else {
          work.style.height = "100%"
        }
      })
    },
    closeQAWrap() {
      this.askQuestion()
    },
    getItemCode(item) {
      console.log(this.isGetCode)
      let editorCode = this.editor.getValue()
      let teacherCode = sessionStorage.getItem('teacherCode')

      if (this.isGetCode) {
        sessionStorage.setItem('teacherCode', editorCode)
        this.isGetCode = false
      }

      this.headerData.forceChangeQAIndex++
      this.headerData.isQA = true
      this.headerData.qaTime = true
      this.headerData.nameQA = item.name || '匿名学员'
      this.editor.setValue(item.code)
    },
    closeQAItem(index) {
      this.qaSet.splice(index, 1)
    },
    noTip() {
      this.isTip = false
      this.isActiveTip = !this.isActiveTip
    },
    checkMenu() {
      this.headerData.isQA = false
      this.headerData.qaTime = false
      this.qatip = false
      this.isGetCode = true

      let teacherCode = sessionStorage.getItem('teacherCode')
      this.editor.setValue(teacherCode)
    },
    noCheckMenu() {
      this.qatip = false
    },
    checkRole(index) {
      if (!index) {
        sessionStorage.setItem('studentCode', this.editor.getValue())
        this.check = 'teacher'
        this.n = 'zore'
        let teacherCode = sessionStorage.getItem('teacherCode')
        this.editor.setValue(teacherCode)
      } else {
        sessionStorage.setItem('teacherCode', this.editor.getValue())
        let studentCode = sessionStorage.getItem('studentCode')
        if (this.check != 'live' && this.n != 'one') {
          this.editor.setValue(studentCode)
          this.n = 'one'
        }
        this.check = 'live'
      }
    }
  }
}
</script>

<style lang="scss">
  @import url('../../style/main.scss');
  .web{
    width: 100%;
    height: 100%;
    background: #eee;
    overflow: hidden;

    // .dragwrap{
    //   width: 100%;
    //   height: calc(100% - 48px);
    //   background-color: #999;

    //   .work{
    //     width: 100%;
    //     height: 100%;
    //     background-color: #fff;
    //   }
    // }

    .workspace{
      height: -webkit-calc(100% - 49px - 260px);
      height: -moz-calc(100% - 49px - 260px);
      height: calc(100% - 49px - 260px);
    }
    .CodeMirror{
      height: 100%;
    }
    .iterm{
      z-index: 9999;
    }
    .el-tabs__header{
      background-color: #F4F6F9;
    }
    .flx{
      width: 100%;
      height: 100%;
      display: flex;
    }
    .qa-tip{
      position: absolute;
      padding: 0 6px;
      background: red;
      text-align: center;
      border-radius: 50%;
      line-height: 1.5;
      top: 0;
      font-size: 12px;
      letter-spacing: 0px;
    }
  }
  .compile{
    padding: 12px 18px;
  }
  .iterm-wrap{
    background: #fff;
  }
  li{
    cursor:pointer
  }
  .t-start, .t-end{
    color: #1FB6FF;
    background-color: #fff;
    font-weight: 400;
    cursor: pointer;
  }
  .t-clear{
    font-weight: 400;
  }
  .choosed{
    color: #FFF;
    background-image: linear-gradient(to right, #1FB6FF 0%, #62DCF5 100%);
    transition: 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) all !important;
    box-shadow: 0px 0px 2px 0px #B3E5FF;
    border: none;
    border-radius: 30px;
  }
  .console{
    position:relative;

    .console-entries{
      width:100%;
      height:calc(100% - 33px)
    }
    .console-command-line{
      border:1px solid #000;
      width:100%;
      height:32px;
      display: -webkit-flex;
      display: -ms-flexbox;
      display: flex;
      position: absolute;
      bottom:0;
      
      span{
        width:32px;
        background: url(../../assets/more.png);
        background-size: 32px
      }
      .console-command-line-input{
        flex:1;
        line-height:30px;
        outline:none    
      }
    }
  }
  .teach-wrap{
    width: 100%;
    height: 100%;
    display: flex;
    
    .teach-area{
      height:100%;
      flex: 1;
      position: relative;
    }
    .v-note-wrapper .v-note-panel .v-note-show .v-show-content, .v-note-wrapper .v-note-panel .v-note-show .v-show-content-html{
      background: #ffffff !important;
    }
    .v-note-wrapper .v-note-panel{
      box-shadow: none;
    }
  }

</style>



// WEBPACK FOOTER //
// web_teacher.vue?92523ef8